import React from 'react'

const Games = () => {
  return (
    <div className='main-container'>Games</div>
  )
}

export default Games 